<template>
  <v-expansion-panels v-if="accordion" accordion flat>
    <v-expansion-panel>
      <v-expansion-panel-header class="body-2 font-weight-medium px-0">
        Evidências ({{ evidencias.length }})
      </v-expansion-panel-header>
      <v-expansion-panel-content class="px-0">
        <v-list dense>
          <v-list-item v-for="evidencia in evidencias" :key="evidencia.id" class="px-0">
            <v-list-item-icon class="mr-3 mt-3">
              <v-icon color="primary">{{ icone }}</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>{{ evidencia.titulo }}</v-list-item-title>
              <v-list-item-subtitle v-if="evidencia.subtitulo">{{ evidencia.subtitulo }}</v-list-item-subtitle>
            </v-list-item-content>
            <v-list-item-action>
              <v-btn
                :aria-label="`Baixar ${evidencia.titulo}`"
                :loading="baixando === evidencia.chave"
                color="primary"
                icon
                small
                type="button"
                @click="$emit('baixar', evidencia)"
              >
                <v-icon small>mdi-download</v-icon>
              </v-btn>
            </v-list-item-action>
          </v-list-item>
        </v-list>
      </v-expansion-panel-content>
    </v-expansion-panel>
  </v-expansion-panels>

  <v-list v-else dense>
    <v-list-item v-for="evidencia in evidencias" :key="evidencia.id" class="px-0">
      <v-list-item-icon class="mr-3">
        <v-icon color="primary">{{ icone }}</v-icon>
      </v-list-item-icon>
      <v-list-item-content>
        <v-list-item-title>{{ evidencia.titulo }}</v-list-item-title>
        <v-list-item-subtitle v-if="evidencia.subtitulo">{{ evidencia.subtitulo }}</v-list-item-subtitle>
      </v-list-item-content>
      <v-list-item-action>
        <v-btn
          :aria-label="`Baixar ${evidencia.titulo}`"
          :loading="baixando === evidencia.chave"
          color="primary"
          icon
          small
          type="button"
          @click="$emit('baixar', evidencia)"
        >
          <v-icon small>mdi-download</v-icon>
        </v-btn>
      </v-list-item-action>
    </v-list-item>
  </v-list>
</template>

<script>
  export default {
    name: 'EvidenciasParaDownload',

    props: {
      evidencias: {
        type: Array,
        default: () => []
      },
      icone: {
        type: String,
        required: true
      },
      baixando: {
        type: String,
        default: ''
      },
      accordion: {
        type: Boolean,
        default: true
      }
    }
  };
</script>
